import { inject } from "vue";
const APP_SETTINGS_REGISTRATION_KEY = /* @__PURE__ */ Symbol.for("NcAppSettingsDialog:registration");
const APP_SETTINGS_LEGACY_DESIGN_KEY = /* @__PURE__ */ Symbol.for("NcAppSettingsDialog:legacy");
function useAppSettingsDialog() {
  return inject(APP_SETTINGS_REGISTRATION_KEY);
}
export {
  APP_SETTINGS_LEGACY_DESIGN_KEY as A,
  APP_SETTINGS_REGISTRATION_KEY as a,
  useAppSettingsDialog as u
};
//# sourceMappingURL=useAppSettingsDialog.mjs.map
